import React from 'react'
import { connect } from 'react-redux'
import { Loader } from 'components/UIElements'
import { setNavBarProps } from 'store/navbar'
import { modalActions } from 'store/modal'
import { USER_SCOPES, GROUP_TYPE_MAP } from 'utils/constants'
import { disableScope, getUserScopeByStudy } from 'utils/misc'
import { announcementActions } from '../modules/Announcement'
import { setCommunicationType } from '../../AnnouncementsPage/modules/Announcements'
import AnnouncementView from '../components/EditAnnouncement'

const mapState = (state, ownProps) => {
  const { params } = ownProps
  const { studyVersionID } = params
  const { announcementReducer, loading, sites = {}, study, studyLock, user } = state
  const { announcement, errors } = announcementReducer
  const studyID = Number(params.studyID)
  const { isDeploy, sendingState, sentState } = state.sending
  const sendDisabled = sendingState || sentState
  const { currentStudy, locales, studyVersionList } = study
  const enforcedLanguage = currentStudy?.config?.enforced_language
  const {
    content,
    deployed,
    disabledLangs,
    num_read,
    num_received,
    num_sent,
    schedule,
    metadata,
    title,
    translations,
  } = announcement
  const { siteSelectionList, leafSites, sitesList } = sites
  const userScope = getUserScopeByStudy(user, currentStudy)
  const canWriteCohort = userScope.includes(USER_SCOPES.wxc.code)
  const noTracksFeature = currentStudy.config?.tracks?.disabled === true

  const hasStudyPromotion = !!study?.currentStudy?.config?.study_promotion

  const getCurrentVersion = () => {
    return studyVersionList?.find(item => item?.version_id === studyVersionID)
  }

  const currentVersion = getCurrentVersion()

  const isCurrentDEV = currentVersion?.version_status?.toLowerCase() === 'dev'

  const isAllowedToEditAnnouncements = isCurrentDEV

  let checkedSites = []
  if (hasStudyPromotion) {
    checkedSites =
      metadata?.schedule?.cohort.type === GROUP_TYPE_MAP.sites
        ? metadata?.schedule?.env_config[currentVersion?.version_status] ?? []
        : []
  } else {
    checkedSites = schedule?.cohort.type === GROUP_TYPE_MAP.sites ? schedule.cohort.filter.site_ids : []
  }

  return {
    announcementId: announcement.id || params.announcementID || params.smsID,
    checkedSites,
    content,
    currentStudy: study.currentStudy,
    deployed,
    deploySending: isDeploy && sendingState,
    deploySent: isDeploy && sentState,
    disabledLangs,
    disableTrackCreation: disableScope({ study, user, scope: USER_SCOPES.wxc.code }) || !canWriteCohort,
    enforcedLanguage,
    errors,
    // Route identity is stable across loader remounts; Redux id is cleared by resetAnnouncement on unmount.
    isCreate: !(params.announcementID || params.smsID || announcement.id),
    leafSites,
    loading: loading.general,
    locales,
    noTracksFeature,
    num_read,
    num_received,
    num_sent,
    readOnly: isAllowedToEditAnnouncements ? false : deployed !== null,
    saveSending: !isDeploy && sendingState,
    saveSent: !isDeploy && sentState,
    schedule: schedule,
    sendDisabled,
    siteSelectionList,
    sitesList,
    studyID,
    studyLock,
    title,
    translations,
    hasStudyPromotion,
  }
}

const mapDispatch = {
  ...announcementActions,
  ...modalActions,
  setNavBarProps,
  setCommunicationType,
}

export default connect(
  mapState,
  mapDispatch,
)(props => {
  // On edit routes, keep the form mounted during transient loaders (CSV upload / refetch).
  // Replacing with <Loader /> unmounts EditAnnouncement → resetAnnouncement() → "New Announcement".
  const isEditRoute = Boolean(props.params?.announcementID || props.params?.smsID)
  if (props.loading && !isEditRoute) return <Loader />
  return <AnnouncementView {...props} />
})
